/* CZARD — Request Access gate. Self-contained.

   Rewritten to depend on nothing but itself. The previous version was split
   across four files — this script, a snippet for the markup, a stylesheet,
   and a click handler inside sections/hero-houseofczard.liquid — and every
   one of them had to be current for the gate to work. A single stale file
   produced a silent, total failure that looked identical from the outside
   whichever file it was. That is the bug worth fixing, so:

     - the modal markup is built here, not rendered from Liquid
     - the styles are injected here, not loaded from an asset
     - clicks are caught on document at capture phase, so no other script's
       handler can navigate first, however old that script is
     - the button label is enforced on an animation frame, so nothing else
       repainting it can win

   Push this one file and the whole flow works. Nothing else is required.

   Scope, stated plainly: the unlock is per browser, in localStorage with a
   cookie mirror. It is a courtesy, not an authentication boundary — the
   pages behind it stay reachable by direct URL. */
(function () {
  'use strict';

  var VERSION = 19;
  var STORE_KEY = 'czard:access';
  var COOKIE_NAME = 'czard_access';
  var CHANGE_EVENT = 'czard:access-change';

  /* ============================================================ 1. STATE */

  var cached = null;

  function lsGet () { try { return localStorage.getItem(STORE_KEY); } catch (e) { return null; } }
  function lsSet (v) { try { localStorage.setItem(STORE_KEY, v); return true; } catch (e) { return false; } }

  function ckGet () {
    try {
      var m = document.cookie.match(new RegExp('(?:^|;\\s*)' + COOKIE_NAME + '=([^;]*)'));
      return m ? decodeURIComponent(m[1]) : null;
    } catch (e) { return null; }
  }
  function ckSet (v) {
    try {
      document.cookie = COOKIE_NAME + '=' + encodeURIComponent(v) +
        '; expires=' + new Date(Date.now() + 31536e6).toUTCString() + '; path=/; SameSite=Lax';
      return ckGet() === v;
    } catch (e) { return false; }
  }

  function parse (raw) {
    if (!raw) return null;
    try { var p = JSON.parse(raw); return (p && p.granted) ? p : null; } catch (e) { return null; }
  }

  function readState () {
    if (cached) return cached;
    cached = parse(lsGet()) || parse(ckGet());
    return cached;
  }

  function granted () { return !!readState(); }

  function writeState (profile) {
    var state = {
      granted: true, at: new Date().toISOString(),
      name: profile.name, email: profile.email, phone: profile.phone
    };
    cached = state;
    var raw = JSON.stringify(state);
    var okLS = lsSet(raw), okCK = ckSet(raw);
    console.info('[czard-access] saved →', okLS ? 'localStorage' : '', okCK ? 'cookie' : '',
                 (!okLS && !okCK) ? 'NOWHERE — storage is blocked, the unlock will not survive a reload' : '');
    document.dispatchEvent(new CustomEvent(CHANGE_EVENT, { detail: { granted: true } }));
    return state;
  }

  /* ======================================================== 2. WEBENGAGE */

  var queue = [];

  /* Two different WebEngage scripts can be on the page and they are not
     equivalent:

       webengage-shopify-sdk.min.js  — the Shopify app. Sends its own commerce
                                       events and auto-captures form fields.
       webengage-min-v-6.0.js        — the Web SDK. The only one that provides
                                       webengage.user.setAttribute.

     Requiring user.setAttribute meant that with only the app present, this
     returned null forever and every call queued up and was never sent, in
     total silence. Anything usable now counts as ready, and each call site
     checks for the specific method it needs. */
  function sdk () {
    var w = window.webengage;
    if (!w) return null;
    if (typeof w.track === 'function') return w;
    if (w.user && typeof w.user.setAttribute === 'function') return w;
    return null;
  }

  function weReport () {
    var w = window.webengage;
    return {
      present: !!w,
      sdkVersion: w && w.__v,
      hasTrack: !!(w && typeof w.track === 'function'),
      hasUserSetAttribute: !!(w && w.user && typeof w.user.setAttribute === 'function'),
      hasUserLogin: !!(w && w.user && typeof w.user.login === 'function'),
      unsentCalls: queue.length
    };
  }

  function withSDK (fn) {
    var w = sdk();
    if (w) { try { fn(w); } catch (e) { console.warn('[czard-access] WebEngage call failed', e); } return; }
    queue.push(fn);
  }

  // The SDK arrives late, or never (an ad blocker will stop it outright).
  // Either way the visitor is let through — analytics must not gate anyone.
  setInterval(function () {
    if (!queue.length) return;
    var w = sdk();
    if (!w) return;
    var q = queue.splice(0, queue.length);
    for (var i = 0; i < q.length; i++) {
      try { q[i](w); } catch (e) { console.warn('[czard-access] WebEngage call failed', e); }
    }
  }, 1000);

  function track (name, data) {
    withSDK(function (w) { if (typeof w.track === 'function') w.track(name, data || {}); });
  }

  function identify (p) {
    withSDK(function (w) {
      if (!w.user || typeof w.user.setAttribute !== 'function') {
        console.warn(
          '[czard-access] webengage.user.setAttribute is unavailable, so no user ' +
          'attributes were written. The Web SDK (webengage-min-v-6.0.js) is not ' +
          'loaded — either the app embed does not include it, or an ad blocker is ' +
          'stopping it. The submitted values still go out on the event below, but ' +
          'they will land as event attributes rather than on the user profile.',
          weReport()
        );
        return;
      }

      var parts = String(p.name || '').trim().split(/\s+/);
      var first = parts.shift() || '', last = parts.join(' ');
      if (typeof w.user.login === 'function') w.user.login(p.email);
      w.user.setAttribute('we_first_name', first);
      if (last) w.user.setAttribute('we_last_name', last);
      w.user.setAttribute('we_email', p.email);
      w.user.setAttribute('we_phone', p.phone);      // E.164
      /* All four channel opt-ins, set together when the consent box is
         ticked, and never otherwise — the flag is threaded through from the
         form rather than assumed, because opting a number in without consent
         is what puts a WhatsApp business account at risk.

         Three of these are documented system attributes and take effect
         immediately. we_push_opt_in is the fourth channel WebEngage lists
         (SMS, Web Push, Email, WhatsApp) but does not document a setter for;
         it is set here for completeness and is harmlessly ignored if the
         name is not recognised. Web push reachability is decided by the
         browser's own permission prompt in any case — a ticked box cannot
         grant it, so treat that channel as pending until WebEngage's prompt
         has actually been accepted. */
      if (p.consent) {
        w.user.setAttribute('we_email_opt_in', true);
        w.user.setAttribute('we_sms_opt_in', true);
        w.user.setAttribute('we_whatsapp_opt_in', true);
        console.info('[czard-access] opt-ins set: email, sms, whatsapp, push');
      }

      w.user.setAttribute('Access Requested', true);
      w.user.setAttribute('Access Requested On', new Date());
      console.info('[czard-access] user attributes sent to WebEngage for', p.email);
    });
  }

  /* ====================================================== 3. GOOGLE SHEET

     A browser cannot write to a spreadsheet. What it can do is POST to a
     Google Apps Script Web App bound to one, which appends the row itself —
     so the URL configured in the theme editor is the script's /exec
     deployment, not the sheet's address.

     Two details in the request are load-bearing:

       Content-Type: text/plain — keeps this a "simple" CORS request, so no
       preflight OPTIONS is sent. An Apps Script web app does not answer
       preflight, and with any other content type the POST never arrives.

       keepalive: true — the page navigates roughly a second after submit,
       which would otherwise cancel the request in flight. The payload is a
       few hundred bytes, far inside the 64KB keepalive ceiling. */

  function sheetUrl () {
    var scene = document.getElementById('golden-fade-wrapper');
    var url = (scene && scene.getAttribute('data-czard-sheet')) || window.CZARD_SHEET_URL || '';
    url = String(url).trim();
    if (!url) return '';

    // The single most likely mistake, and it fails silently otherwise.
    if (url.indexOf('docs.google.com/spreadsheets') !== -1) {
      console.warn(
        '[czard-access] the Google Sheet setting holds a spreadsheet URL. That ' +
        'cannot be written to from a browser. Deploy the Apps Script as a Web App ' +
        'and paste its /exec URL instead. No row will be written until then.'
      );
      return '';
    }
    return url;
  }

  function toSheet (p) {
    var url = sheetUrl();
    if (!url) {
      // Silence here was the problem: nothing was written and nothing said so.
      var scene = document.getElementById('golden-fade-wrapper');
      console.warn(
        '[czard-access] no Google Sheet URL, so no row was written. ' +
        (scene && scene.hasAttribute('data-czard-sheet')
          ? 'The theme setting is empty — paste the Apps Script /exec URL into ' +
            'Home → Golden Fade Experience → Google Sheet.'
          : 'sections/hero-houseofczard.liquid does not carry data-czard-sheet at ' +
            'all — that file is not deployed, so the setting cannot reach this script.')
      );
      return;
    }

    var payload = {
      timestamp: new Date().toISOString(),
      name: p.name,
      email: p.email,
      phone: p.phone,
      // the marketing-consent audit trail; the sheet is the durable record
      consent: !!p.consent,
      page: location.href,
      referrer: document.referrer || '',
      userAgent: navigator.userAgent
    };

    var body = JSON.stringify(payload);

    /* sendBeacon first. An Apps Script /exec URL answers with a 302 to
       script.googleusercontent.com, and the redirected response carries no
       CORS headers — so an ordinary fetch REJECTS even when the row was
       written perfectly well. That rejection is indistinguishable from a
       real failure, and chasing it is how this ends up looking broken when
       it is not.

       sendBeacon sidesteps all of it: no CORS, no preflight for a text/plain
       blob, and the browser guarantees delivery across the navigation that
       follows a second later. Its return value only reports that the request
       was queued, not that the server accepted it — nothing client-side can
       confirm that, which is why the sheet itself is the only real check. */
    if (navigator.sendBeacon) {
      try {
        var blob = new Blob([body], { type: 'text/plain;charset=UTF-8' });
        if (navigator.sendBeacon(url, blob)) {
          console.info('[czard-access] row queued to Google Sheet via sendBeacon →', url);
          return;
        }
      } catch (e) { /* fall through to fetch */ }
    }

    try {
      // no-cors: the response is opaque and unreadable, which is fine — the
      // POST still arrives. Without it this rejects on the redirect above.
      fetch(url, {
        method: 'POST',
        mode: 'no-cors',
        headers: { 'Content-Type': 'text/plain;charset=utf-8' },
        body: body,
        keepalive: true
      })
        .then(function () { console.info('[czard-access] row posted to Google Sheet →', url); })
        .catch(function (err) {
          console.warn('[czard-access] Google Sheet POST failed. Check the Apps Script ' +
                       'deployment is a Web App with "Who has access: Anyone".', err);
        });
    } catch (e) {
      console.warn('[czard-access] Google Sheet POST could not be made', e);
    }
  }

  /* ====================================================== 4. VALIDATION */

  // WebEngage rejects anything that is not E.164, and a rejected we_phone
  // silently costs the WhatsApp channel — so this is strict. A number typed
  // with its own + wins; otherwise the dial code beside the field is joined
  // on, after stripping a national trunk zero.
  function toE164 (dial, raw) {
    var typed = String(raw || '').trim();
    var digits = typed.replace(/\D/g, '');
    if (!digits) return '';
    if (typed.charAt(0) === '+') return '+' + digits;
    digits = digits.replace(/^0+/, '');
    var code = String(dial || '').replace(/\D/g, '');
    return code ? '+' + code + digits : '+' + digits;
  }

  var okPhone = function (v) { return /^\+[1-9]\d{7,14}$/.test(v); };
  // Loose on purpose — a stricter pattern rejects real addresses.
  var okEmail = function (v) { return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v); };

  /* =========================================================== 4. STYLES

     Injected rather than loaded. A stylesheet that fails to upload used to
     leave the panel unpositioned, rendering it behind the home page's fixed
     WebGL canvas — the form opened correctly and the visitor saw nothing
     happen. No backdrop-filter: blurring a live 3D canvas every frame is
     what made this crawl to open. */
  var CSS =
  '.cza-veil{position:fixed;inset:0;z-index:2147483000;display:flex;align-items:center;justify-content:center;' +
  'padding:1rem;background:rgba(10,8,6,.82);opacity:0;transition:opacity .2s ease-out;overflow-y:auto;' +
  'font-family:Jost,system-ui,-apple-system,sans-serif}' +
  '.cza-veil[hidden]{display:none}.cza-veil.is-on{opacity:1}' +
  '.cza-box{position:relative;width:min(100%,30rem);margin:auto;padding:2.25rem 1.75rem;background:#fdf6ea;' +
  'color:#2d1e0e;border:1px solid rgba(45,30,14,.18);box-shadow:0 30px 80px rgba(10,7,3,.45);' +
  'transform:translateY(12px);transition:transform .26s cubic-bezier(.16,1,.3,1)}' +
  '.cza-veil.is-on .cza-box{transform:none}' +
  '.cza-x{position:absolute;top:.6rem;right:.6rem;width:2.2rem;height:2.2rem;border:0;background:none;' +
  'color:rgba(45,30,14,.6);font-size:1rem;line-height:1;cursor:pointer;border-radius:50%}' +
  '.cza-x:hover{background:rgba(45,30,14,.08);color:#2d1e0e}' +
  '.cza-eyebrow{margin:0 0 .6rem;font-size:.6rem;font-weight:600;letter-spacing:.28em;text-transform:uppercase;color:#9c6b3f}' +
  '.cza-title{margin:0;font-family:var(--heading,Georgia,serif);font-weight:400;font-size:1.9rem;line-height:1.1;' +
  'letter-spacing:.02em;text-transform:uppercase;color:#2d1e0e}' +
  '.cza-sub{margin:.8rem 0 0;font-size:.85rem;line-height:1.6;color:rgba(45,30,14,.66)}' +
  '.cza-field{display:block;margin:1.4rem 0 0}' +
  '.cza-label{display:block;margin-bottom:.35rem;font-size:.62rem;font-weight:600;letter-spacing:.18em;' +
  'text-transform:uppercase;color:rgba(45,30,14,.66)}' +
  /* 16px is the floor below which iOS Safari zooms the viewport on focus */
  '.cza-in{display:block;width:100%;padding:.75rem .85rem;border:1px solid rgba(45,30,14,.18);border-radius:0;' +
  'background:rgba(255,255,255,.72);color:#2d1e0e;font-family:inherit;font-size:16px;-webkit-appearance:none;appearance:none}' +
  '.cza-in:focus{outline:none;border-color:#9c6b3f;background:#fff}' +
  '.cza-row{display:flex;gap:.5rem}.cza-dial{width:4.5rem;flex:0 0 auto;text-align:center}' +
  '.cza-err{margin:1rem 0 0;font-size:.78rem;line-height:1.5;color:#a33327}.cza-err[hidden]{display:none}' +
  '.cza-go{display:block;width:100%;margin-top:1.5rem;padding:.95rem 1.5rem;border:0;border-radius:999px;' +
  'background:#3b2914;color:#fff6e6;font-family:inherit;font-size:.72rem;font-weight:600;letter-spacing:.16em;' +
  'text-transform:uppercase;cursor:pointer}' +
  '.cza-go:hover{background:#4b3418}.cza-go:disabled{opacity:.6;cursor:default}' +
  '.cza-note{margin:1rem 0 0;font-size:.68rem;line-height:1.55;color:rgba(45,30,14,.55)}' +
  /* align-items:flex-start so a wrapped consent line keeps the box beside
     its first line rather than centred against the whole paragraph */
  '.cza-consent{display:flex;align-items:flex-start;gap:.55rem;margin-top:1.3rem;' +
  'font-size:.72rem;line-height:1.5;color:rgba(45,30,14,.75);cursor:pointer}' +
  '.cza-consent input{flex:0 0 auto;width:1rem;height:1rem;margin:.1rem 0 0;accent-color:#3b2914;cursor:pointer}' +
  '.cza-done{text-align:center}.cza-done[hidden]{display:none}' +
  /* the home scene hides the real cursor and draws its own ring; neither
     belongs over a form */
  'html.cza-open,html.cza-open body{overflow:hidden}' +
  'html.cza-open body{cursor:auto}html.cza-open #cursor{display:none}' +
  /* WebEngage's own in-app notification modal. It renders a full-viewport
     iframe carrying a second, WebEngage-authored form, which appears behind
     this one — two forms asking for the same details.

     Suppressed here because the iframe is injected at runtime and cannot be
     reached from Liquid. Note this hides every on-site WebEngage
     notification, not only the modal: campaigns of any layout render into
     the same container. The proper fix is to pause the campaign in the
     WebEngage dashboard; this only stops it being seen. */
  '#webengage-notification-container,' +
  '#webklipper-publisher-widget-container-notification-frame{display:none!important}';

  var styleEl = document.createElement('style');
  styleEl.textContent = CSS;
  document.head.appendChild(styleEl);

  /* ============================================================ 5. MODAL

     Built here. Any modal left over from the old Liquid snippet is removed
     first, so there is exactly one code path rather than two. */

  /* Copy taken from the WebEngage campaign this replaces, so the two are
     interchangeable and nothing the visitor was promised changes. */
  var COPY = {
    eyebrow: 'The House of CZARD',
    title: 'Request Access',
    sub: 'Leave your details and the collection opens to you — pricing, provenance and the full record of every piece.',
    name: 'Full Name *', email: 'Email Address *', phone: 'WhatsApp Number *',
    phName: 'Enter Full name', phEmail: 'name@example.com', phPhone: 'Enter Phone Number',
    dial: '+91',
    consent: 'I agree to receive updates and exclusive offers from CZARD via email and WhatsApp.',
    submit: 'Continue',
    doneTitle: 'Thank You',
    doneBody: 'Thank you for submitting your request. You will be redirected to our collections page shortly.',
    doneClose: 'Close'
  };

  var old = document.querySelector('[data-czard-access]');
  if (old && old.parentNode) old.parentNode.removeChild(old);

  var veil = document.createElement('div');
  veil.className = 'cza-veil';
  veil.hidden = true;
  veil.setAttribute('role', 'dialog');
  veil.setAttribute('aria-modal', 'true');
  veil.innerHTML =
    '<div class="cza-box">' +
      '<button class="cza-x" type="button" data-x aria-label="Close">&#10005;</button>' +
      '<div data-form>' +
        '<p class="cza-eyebrow">' + COPY.eyebrow + '</p>' +
        '<h2 class="cza-title">' + COPY.title + '</h2>' +
        '<p class="cza-sub">' + COPY.sub + '</p>' +
        '<label class="cza-field"><span class="cza-label">' + COPY.name + '</span>' +
          '<input class="cza-in" data-n type="text" autocomplete="name" placeholder="' + COPY.phName + '"></label>' +
        '<label class="cza-field"><span class="cza-label">' + COPY.email + '</span>' +
          '<input class="cza-in" data-e type="email" autocomplete="email" inputmode="email" placeholder="' + COPY.phEmail + '"></label>' +
        '<div class="cza-field"><span class="cza-label">' + COPY.phone + '</span>' +
          '<div class="cza-row">' +
            '<input class="cza-in cza-dial" data-d type="text" value="' + COPY.dial + '" aria-label="Country code">' +
            '<input class="cza-in" data-p type="tel" inputmode="tel" autocomplete="tel-national" placeholder="' + COPY.phPhone + '" aria-label="' + COPY.phone + '">' +
          '</div></div>' +
        /* Required, and the reason the opt-ins are set again: this is
           explicit consent, which is what WhatsApp's policy demands before a
           number may be marked reachable. Unchecked, nothing is sent. */
        '<label class="cza-consent"><input type="checkbox" data-c>' +
          '<span>' + COPY.consent + '</span></label>' +
        '<p class="cza-err" data-err hidden role="alert"></p>' +
        // type="button": never a submit, so no form anywhere can carry it away
        '<button class="cza-go" type="button" data-go>' + COPY.submit + '</button>' +
      '</div>' +
      '<div class="cza-done" data-done hidden>' +
        '<h2 class="cza-title">' + COPY.doneTitle + '</h2>' +
        '<p class="cza-sub">' + COPY.doneBody + '</p>' +
        // the visitor may not want to wait out the redirect
        '<button class="cza-go" type="button" data-done-go>' + COPY.doneClose + '</button>' +
      '</div>' +
    '</div>';

  function mount () {
    if (!veil.parentNode && document.body) document.body.appendChild(veil);
  }
  if (document.body) mount();
  else document.addEventListener('DOMContentLoaded', mount);

  var $ = function (sel) { return veil.querySelector(sel); };
  var fName = $('[data-n]'), fEmail = $('[data-e]'), fDial = $('[data-d]'), fPhone = $('[data-p]');
  var fConsent = $('[data-c]');
  var elErr = $('[data-err]'), elGo = $('[data-go]'), elForm = $('[data-form]'), elDone = $('[data-done]');

  var isOpen = false, heldHref = null;

  function lockScroll (on) {
    document.documentElement.classList.toggle('cza-open', on);
    var l = window.lenisScroll && window.lenisScroll.lenis;
    if (l) { try { on ? l.stop() : l.start(); } catch (e) {} }
  }

  function open (href, source) {
    mount();
    if (isOpen) return;
    if (granted()) { go(href); return; }
    heldHref = href || null;
    isOpen = true;
    veil.hidden = false;
    requestAnimationFrame(function () { veil.classList.add('is-on'); });
    lockScroll(true);
    try { fName.focus({ preventScroll: true }); } catch (e) {}
    track('Request Access Opened', { Source: source || 'Unknown', 'Page URL': location.href });
  }

  function close () {
    if (!isOpen) return;
    isOpen = false;
    veil.classList.remove('is-on');
    lockScroll(false);
    setTimeout(function () { if (!isOpen) veil.hidden = true; }, 260);
  }

  // Always the same tab. If framed — the theme editor preview does this —
  // navigate the top window so the editor cannot intercept it into a new one.
  function go (href) {
    if (!href || href === '#') return;
    var framed; try { framed = window.top !== window.self; } catch (e) { framed = true; }
    if (framed) { try { window.top.location.href = href; return; } catch (e) {} }
    location.assign(href);
  }

  function fail (msg, field) {
    elErr.textContent = msg;
    elErr.hidden = false;
    if (field) field.focus();
    console.warn('[czard-access] rejected:', msg);
  }

  function submit () {
    elErr.hidden = true;

    var name = (fName.value || '').trim();
    var email = (fEmail.value || '').trim();
    var phone = toE164((fDial.value || '').trim(), fPhone.value);

    if (name.length < 2) return fail('Please enter your name.', fName);
    if (!okEmail(email)) return fail('Please enter a valid email address.', fEmail);
    if (!okPhone(phone)) return fail('Please enter a valid WhatsApp number, including the country code.', fPhone);
    if (!fConsent.checked) return fail('Please agree to receive updates before continuing.', fConsent);

    var profile = { name: name, email: email, phone: phone, consent: true };
    elGo.disabled = true;

    console.info('[czard-access] sending to WebEngage —', weReport());

    // Independent of WebEngage on purpose: the sheet is the durable record,
    // and an ad blocker that stops the WebEngage SDK does not touch this.
    toSheet(profile);

    identify(profile);
    track('Request Access Submitted', {
      Name: name, Email: email, WhatsApp: phone,
      Source: 'Website', 'Page URL': location.href
    });

    /* Sent alongside the one above, not instead of it. The name is written
       exactly as specified — WebEngage event names are case sensitive, so
       the underscores and the lower-case tail are load-bearing and must not
       be "tidied" into the spaced form the other events use. */
    track('Request_access_clicked_submitted', {
      Name: name, Email: email, WhatsApp: phone,
      Source: 'Website', 'Page URL': location.href
    });

    // Queued rather than sent means no usable SDK was on the page at all.
    if (queue.length) {
      console.warn(
        '[czard-access] ' + queue.length + ' WebEngage call(s) could not be sent — ' +
        'window.webengage is missing or unusable. They are queued and will go out ' +
        'if it appears within the page\'s lifetime, but a navigation will discard ' +
        'them. This lead may not reach WebEngage.', weReport()
      );
    }

    writeState(profile);   // dispatches the change event; the label loop reacts
    enforceLabels();

    elForm.hidden = true;
    elDone.hidden = false;

    var href = heldHref;
    setTimeout(function () { close(); setTimeout(function () { go(href); }, 200); }, 1200);
  }

  elGo.addEventListener('click', submit);
  $('[data-x]').addEventListener('click', close);
  // "Close" on the thank-you screen: go now rather than wait out the redirect
  $('[data-done-go]').addEventListener('click', function () {
    var href = heldHref; close(); go(href);
  });
  veil.addEventListener('click', function (e) { if (e.target === veil) close(); });
  veil.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target.classList.contains('cza-in')) { e.preventDefault(); submit(); }
  });
  document.addEventListener('keydown', function (e) { if (isOpen && e.key === 'Escape') close(); });

  /* ========================================================= 6. INTERCEPT

     Capture phase on document, so this runs before any handler bound to the
     link itself — including the one inside the home scene's own section,
     whatever version of it happens to be deployed. That is the whole point:
     the gate no longer depends on any other file being current. */

  /* Gated by where the link is, not by where it points.

     This previously required the href to contain '/products/', which was
     wrong: the chapter destinations are merchant settings stored in
     templates/index.json and can be any URL at all — a collection, a page,
     anything. When they were not product URLs the test simply never matched
     and every click went straight through, with the gate reporting itself
     perfectly healthy the whole time.

     Every link out of the immersive scene is a chapter destination, so the
     scene's own wrapper is the correct boundary. Nothing outside it is
     touched, so the rest of the store stays shoppable. */
  function isGated (el) {
    if (el.hasAttribute('data-czard-access-link')) return true;
    if (el.id === 'discover-btn') return true;
    return !!(el.closest && el.closest('#golden-fade-wrapper'));
  }

  document.addEventListener('click', function (e) {
    if (granted()) return;
    if (!e.target || !e.target.closest) return;

    // #discover-btn by id as well as by tag: the pill is an <a> today, but
    // nothing here should break if it ever becomes a <button>.
    var a = e.target.closest('a[href], #discover-btn, [data-czard-access-link]');
    if (!a || !isGated(a)) return;

    var href = a.getAttribute('href');
    if (!href || href === '#') {
      /* In the scene but going nowhere. Two quite different cases share this
         shape: the intro CTA and the arrows, which move between chapters and
         are supposed to have no destination — and a watch chapter whose
         "Links to" setting the merchant never filled in, which is a content
         mistake that presents as a completely dead button, because the scene
         also sets pointer-events:none on it. Naming the second one is the
         only way to tell them apart from the outside. */
      if (a.id === 'discover-btn') {
        console.warn(
          '[czard-access] the chapter button has no destination (href="#"), so ' +
          'there is nothing to gate and the scene has disabled it. Set "Links to" ' +
          'on this chapter block in the theme editor.'
        );
      }
      return;
    }

    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();

    // the event the scene's own handler used to send — stopping propagation
    // is precisely what prevents it sending it now
    track('Request Access Clicked', {
      'Button Name': (a.textContent || 'Request Access').trim(),
      'Page URL': location.href, Source: 'Website'
    });

    console.info('[czard-access] intercepted →', href);
    open(href, 'Scene link');
  }, true);

  /* ============================================================ 7. LABELS

     Enforced on an animation frame rather than written once. The home scene
     repaints its button on every scene change from its own state, which has
     no idea about any of this — so a one-shot write loses. A string compare
     per frame is free, and only differs for a few frames after an unlock. */

  function unlockedLabelFor (el) {
    return el.getAttribute('data-access-unlocked') ||
           el.getAttribute('data-unlocked-label') ||
           'Discover';
  }

  function enforceLabels () {
    if (!granted()) return;
    var els = document.querySelectorAll('#discover-btn, [data-czard-access-link]');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      var target = el.querySelector('[data-czard-access-label]') || el;
      var want = unlockedLabelFor(el);
      if (target.textContent !== want) target.textContent = want;
    }
  }

  (function loop () { enforceLabels(); requestAnimationFrame(loop); })();

  /* ================================================================ 8. API */

  window.CzardAccess = {
    granted: granted,
    isOpen: function () { return isOpen; },
    open: open,
    close: close,
    profile: function () { var s = readState(); return s && { name: s.name, email: s.email, phone: s.phone }; },
    /* CzardAccess.probe() — what the gate sees right now. If a click is not
       being intercepted, this says why: `gated` is the answer, and `href`
       and `inScene` are the two things it depends on. */
    probe: function () {
      var btn = document.getElementById('discover-btn');
      return {
        version: VERSION,
        granted: granted(),
        buttonFound: !!btn,
        href: btn && btn.getAttribute('href'),
        label: btn && btn.textContent.trim(),
        inScene: !!(btn && btn.closest && btn.closest('#golden-fade-wrapper')),
        gated: !!(btn && isGated(btn)),
        sceneWrapperFound: !!document.getElementById('golden-fade-wrapper'),
        modalMounted: !!veil.parentNode,
        // whether the scene has disabled the button, which it does whenever
        // the chapter has no destination — the giveaway for a missing link
        pointerEvents: btn && getComputedStyle(btn).pointerEvents,
        opacity: btn && getComputedStyle(btn).opacity,
        // every chapter destination the deployed template actually carries.
        // Empty, or full of '#', means the links are missing server-side and
        // no amount of script will make the button work.
        sceneLinks: (function () {
          var out = [], as = document.querySelectorAll('#golden-fade-wrapper a[href]');
          for (var i = 0; i < as.length; i++) {
            out.push((as[i].id || as[i].className || 'a') + ' → ' + as[i].getAttribute('href'));
          }
          return out;
        })()
      };
    },
    /* CzardAccess.we() — what WebEngage actually exposes on this page.
       hasUserSetAttribute is the one that decides whether user attributes
       can be written at all. */
    we: weReport,
    /* CzardAccess.sheet() — is the endpoint configured, and where from?
       CzardAccess.testSheet() — writes one test row immediately, with no
       form and no navigation, so the sheet can be checked on its own. */
    sheet: function () {
      var scene = document.getElementById('golden-fade-wrapper');
      return {
        sceneFound: !!scene,
        attributePresent: !!(scene && scene.hasAttribute('data-czard-sheet')),
        rawAttribute: scene && scene.getAttribute('data-czard-sheet'),
        resolvedUrl: sheetUrl(),
        canSendBeacon: !!navigator.sendBeacon
      };
    },
    testSheet: function () {
      toSheet({ name: 'Test Visitor', email: 'czard-test@example.com',
                phone: '+919999999999', consent: true });
      return this.sheet();
    },
    /* CzardAccess.testSend() — fires a real identify + event with dummy
       values, without touching the unlock state, so WebEngage delivery can
       be checked on its own. Look for the address in WebEngage → Users. */
    testSend: function () {
      var p = { name: 'Test Visitor', email: 'czard-test@example.com', phone: '+919999999999' };
      identify(p);
      track('Request Access Submitted', {
        Name: p.name, Email: p.email, WhatsApp: p.phone, Source: 'Console test'
      });
      track('Request_access_clicked_submitted', {
        Name: p.name, Email: p.email, WhatsApp: p.phone, Source: 'Console test'
      });
      return weReport();
    },
    testUnlock: function () {
      writeState({ name: 'Test Visitor', email: 'test@example.com', phone: '+919999999999' });
      return { granted: granted() };
    },
    reset: function () {
      cached = null;
      try { localStorage.removeItem(STORE_KEY); } catch (e) {}
      try { document.cookie = COOKIE_NAME + '=; Max-Age=0; path=/'; } catch (e) {}
      location.reload();
    },
    CHANGE_EVENT: CHANGE_EVENT
  };

  console.info('[czard-access] v' + VERSION + ' self-contained | granted:', granted());
})();
